import { writable, derived } from "svelte/store";
import type { Locale } from "date-fns";
import { ko, enUS } from "date-fns/locale";
import { formatDistance as dFormatDistance, format as dFormat } from "date-fns";
import i18next from "@hitit/translations";

const dateLocales: Record<string, Locale> = {
	ko,
	enUS,
};

export const i18n = writable(i18next);
export const t = derived(i18n, (v) => v.t.bind(v));

export const format = derived(
	i18n,
	(v) =>
		function (date: number | Date, formatStr = "PP") {
			return dFormat(date, formatStr, {
				locale: dateLocales[v.language],
			});
		}
);

export const formatDistance = derived(
	i18n,
	(v) =>
		function (
			date: number | Date,
			baseDate: number | Date,
			options: Record<string, unknown>
		) {
			return dFormatDistance(date, baseDate, {
				locale: dateLocales[v.language],
				...options,
			});
		}
);